import {
  DisplayQstnType1,
  DisplayQstnType16,
  DisplayQstnType3,
  DisplayQstnType4,
  DisplayQstnType6,
  DisplayQstnType8,
  DisplayQstnType9,
} from "./displayQstnTypes";

import ArrowPanel from "./arrowPanel";
import { commonLabels } from "../util/commonLabelAndFontSize";

function DisplayQuestions({
  questions,
  categoryName,
  categoryId,
  questionsPanel,
  isDisabled,
  handlePanel,
  activeJoyrideCategory,
  medium,
}) {
  const labels = commonLabels[medium === "hindi" ? "hi" : "en"];

  return (
    <>
      <ArrowPanel
        panel={questionsPanel}
        event={handlePanel}
        label={labels.questions}
      />
      <br />
      {questionsPanel && (
        <>
          <div
            style={{
              maxHeight: "280px", // ✅ fixed height (adjust if needed)
              overflowY: "auto", // ✅ vertical scroll
              overflowX: "hidden", // ✅ no horizontal scroll
              paddingRight: "6px", // ✅ space for scrollbar
            }}
            className={`
  step-questions-${categoryId}
  ${activeJoyrideCategory === categoryId ? "questions-select-step" : ""}
`}
          >
            {questions.length > 0 ? (
              <>
                <span>
                  {questions.slice(0, 5).map((question, i) => (
                    <WrapComponent
                      key={i}
                      i={i}
                      question={question}
                      isDisabled={isDisabled}
                    />
                  ))}
                </span>
                {questions.slice(5).map((question, i) => (
                  <WrapComponent
                    key={i}
                    i={i}
                    question={question}
                    isDisabled={isDisabled}
                  />
                ))}
              </>
            ) : (
              <div>{labels.noQuestionsFound}</div>
            )}
          </div>
        </>
      )}
    </>
  );
}

function WrapComponent({ isDisabled, i, question }) {
  const { question_typeid } = question;

  const renderQuestionComponent = () => {
    switch (question_typeid) {
      case 1:
      case 30:
        return (
          <DisplayQstnType1
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 3:
        return (
          <DisplayQstnType3
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 4:
      case 5:
        return (
          <DisplayQstnType4
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 6:
        return (
          <DisplayQstnType6
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 8:
        return (
          <DisplayQstnType8
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 9:
      case 10:
      case 11:
      case 15:
        return (
          <DisplayQstnType9
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      case 16:
        return (
          <DisplayQstnType16
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
      default:
        return (
          <DisplayQstnType9
            question={question}
            key={i + 1}
            id={`question-${i + 1}`}
          />
        );
    }
  };

  return (
    <div key={i + 1}>
      <fieldset disabled={isDisabled}>{renderQuestionComponent()}</fieldset>
    </div>
  );
}

export default DisplayQuestions;
